// The shared axios instance sets no timeout, so a request that never answers is
// never abandoned — it waits for whatever cuts the connection upstream, which is
// how /admin came to spin for half a minute before showing an error.
//
// Long enough that a slow-but-working endpoint still answers, short enough that a
// widget which is not coming back says so while the rest of the page is usable.
export const DASHBOARD_REQUEST_TIMEOUT_MS = 15_000;
